package com.shadowings.gero.data.datasource

import com.shadowings.gero.domain.model.Chapter

class JsonChapterDataSource(private val chapters: List<Chapter>) {
    fun getChapters(): List<Chapter> {
        return chapters
    }
}

